// extracted by mini-css-extract-plugin
module.exports = {"container":"_1awc6OctCTi64plJ-K42D8"};